module.exports = __webpack_public_path__ + "static/farahwbg-b80bf06f71a27b0b9c5801f6f42eab14.png";